(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    const swatchSelector = '.variant-picker .color-swatch, .variant-picker .thumbnail-swatch';
    let tooltip;

    const hideTooltip = () => tooltip?.removeAttribute('data-visible');

    document.addEventListener('pointerover', (event) => {
      if (event.pointerType !== 'mouse' || !(event.target instanceof Element)) return;

      const swatch = event.target.closest(swatchSelector);
      const value = swatch?.control?.value;
      if (!value) return;

      if (!tooltip) {
        tooltip = document.createElement('div');
        tooltip.className = 'variant-swatch-tooltip';
        tooltip.setAttribute('aria-hidden', 'true');
        document.body.append(tooltip);
        window.addEventListener('scroll', hideTooltip, { passive: true, capture: true });
      }

      const rect = swatch.getBoundingClientRect();
      tooltip.textContent = value;
      tooltip.style.left = `${rect.left + rect.width / 2}px`;
      tooltip.style.top = `${rect.top}px`;
      tooltip.setAttribute('data-visible', '');
    });

    document.addEventListener('pointerout', (event) => {
      if (!(event.target instanceof Element)) return;

      const swatch = event.target.closest(swatchSelector);
      if (!swatch) return;
      if (event.relatedTarget instanceof Node && swatch.contains(event.relatedTarget)) return;

      hideTooltip();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
